import React from "react";
import { useRafflePageContext } from "@/apps/raffle/pages/RafflePage/RafflePageContext";
import { RaffleWheelProvider } from "./RaffleWheelContext";
import { WheelSurface } from "./WheelSurface";

export const RaffleWheel = () => {
  const {
    currentParticipantIndex,
    participants,
    resultsAnimation,
  } = useRafflePageContext();
  const activeParticipantIndex =
    resultsAnimation.activeParticipantIndex ?? currentParticipantIndex;

  return (
    <RaffleWheelProvider
      participants={participants}
      currentParticipantIndex={activeParticipantIndex}
      rotation={resultsAnimation.rotation}
    >
      <WheelSurface />
    </RaffleWheelProvider>
  );
};
